var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{directives:[{name:"bem",rawName:"v-bem.input",modifiers:{"input":true}}],staticClass:"static-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.inputLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }